import utility from '@/mixins/utility'

class Domain {

  #data = {}

  #group = null

  constructor(data={})
  {
    this.#data = data

    if( data.group )
      this.#group = utility.methods.mapModel(data.group, 'group')
  }

  /**
   * Property getters.
   */
  
  get active()
  {
    return this.#data.active == true
  }

  get host()
  {
    return this.#data.host
  }

  /**
   * Computed properties.
   */
  

  /**
   * Relationships.
   */
  
  get group()
  {
    return this.#group
  }


  /**
   * Methods.
   */
  

}

export default Domain